import React, { useState, useContext } from "react";
import {
  CustomToolTip,
  CustomToggleButton,
  AddToolTip,
} from "../../../components";
import { InputGroup, Button, Form, Row } from "react-bootstrap";
import "../../../styles/containers/MapperAssociatePlans.scss";
import AddPlanButton from "./AddPlanButton";
import SearchBar from "./SearchBar";
import "../../../styles/containers/AddPlanSlider.scss";
import {
  manageMapperStore,
  setManageMapperToastInfo,
  UpdateApiMappings,
} from "../../../contexts";
import FiltersDropDown from "./FiltersDropDown";
import {
  LoaderWrapper,
  SliderPanel,
  Link,
  CsplTable as Table,
  Dropside,
} from "../../../components";
import {
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  toMultiSelectValueById,
} from "../../../utils";
import { isEmpty } from "lodash";
import { faTimes, faChevronDown } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getActivePlans,
  onUpdateOutputPlans,
  onUpdatePlans,
} from "../../../services";
import { useDeepEffect } from "../../../abstracts";

const ManageAddPlanButton = (props) => {
  const {
    savedPlans,
    setSavedPlans,
    planProfiles,
    mappingConfigurationId,
    mapType,
    mappedPlans,
    apiOutput,
  } = props;
  const { dispatch } = useContext(manageMapperStore);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditSliderOpen, setEditSliderOpen] = useState(false);
  const [searchAddedPlans, setSearchAddedPlans] = useState("");
  const [searchSavedPlans, setSearchSavedPlans] = useState("");
  const [searchPlanList, setSearchPlanList] = useState("");
  const [tags, setTags] = useState([]);
  const [addedPlans, setAddedPlans] = useState([]);
  const [addedPlansFilter, setAddedPlansFilter] = useState([]);
  const [savedPlansFilter, setSavedPlansFilter] = useState([]);
  const [loader, setLoader] = useState(true);
  const [planListFilter, setPlanListFilter] = useState([]);
  const [plans, setPlans] = useState([]);
  const [selectedPlanTypes, setSelectedPlanTypes] = useState([]);
  const [selectedCompanyNames, setSelectedCompanyNames] = useState([]);
  const [allPlans, setAllPlans] = useState([]);
  const [plansForOptions, setplansForOptions] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const planTypes = toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.PLAN_TYPES);

  const clearFilterValues = () => {
    setSelectedPlanTypes([]);
    setSelectedCompanyNames([]);
    setTags([]);
    setLoader(true);
    getActivePlans({
      planType: [],
      companyId: [],
    }).then((response) => {
      setLoader(false);
      setAllPlans(response);
    });

    // setLoader(true);
  };

  useDeepEffect(() => {
    if (!isEmpty(savedPlans)) {
      let plans = [];
      savedPlans.map((plan) => {
        allPlans.map((item) => {
          if (item.planId == plan.planId) {
            plans = [...plans, { ...plan, planStatus: item.planStatus }];
          }
        });
      });
      setAddedPlans(plans);
      setAddedPlansFilter(plans);
    }
  }, [savedPlans, allPlans]);

  useDeepEffect(() => {
    getActivePlans({
      planType: [],
      companyId: [],
    }).then((response) => {
      setLoader(false);
      setplansForOptions(response);
    });
  }, [isEditSliderOpen]);

  const applyFiltersClick = () => {
    setLoader(true);
    getActivePlans({
      planType: selectedPlanTypes,
      companyId: selectedCompanyNames,
    }).then((response) => {
      setLoader(false);
      setAllPlans(response);
    });
  };

  const companyNamesList = [];
  plansForOptions.map((item, i) => {
    if (!companyNamesList.includes(item.companyId)) {
      companyNamesList.push({ label: item.companyName, value: item.companyId });
    }
  });

  const companyOptions = companyNamesList.filter((obj, pos, arr) => {
    return arr.map((mapObj) => mapObj.value).indexOf(obj.value) == pos;
  });

  const onDeleteFilterClick = (index, itemIndex) => {
    let data = tags[index][0].filter((item) => item.value !== itemIndex);
    setTags({ ...tags, [index]: [data] });
    let ids = data.map((id) => id.value);
    switch (index) {
      case 1:
        setSelectedPlanTypes(ids);
        break;
      case 2:
        setSelectedCompanyNames(ids);
        break;
      default:
        break;
    }
  };

  const filters = [planTypes, companyOptions];

  const handleFilters = (list, values) => {
    let data = filters[list - 1].filter((item) =>
      values.map((x) => x).includes(item.value)
    );
    setTags({ ...tags, [list]: [data] });
  };

  const addPlansToPlanGroup = (data) => {
    setAddedPlans([data, ...addedPlans]);
    if (
      data.planName.toLowerCase().includes(searchAddedPlans.toLowerCase()) ||
      data.rkPlanNumber.includes(searchAddedPlans)
    ) {
      setAddedPlansFilter([data, ...addedPlansFilter]);
    }
    setPlans(plans.filter((e) => e.planId !== data.planId));
    setPlanListFilter(planListFilter.filter((e) => e.planId !== data.planId));
  };

  const onViewButtonClick = () => {
    setModalOpen(true);
  };
  const onEditButtonClick = () => {
    setEditSliderOpen(true);
  };

  const onEditAddedPlansButtonClick = () => {
    setEditSliderOpen(false);
    setModalOpen(true);
  };
  const onCloseAddedPlansButtonClick = () => {
    setSearchSavedPlans("");
    setEditSliderOpen(false);
  };

  const onSubmit = (plans) => {
    // if (plans.length !== planProfiles.length)
    if (mappingConfigurationId) {
      if (mapType == 1 || apiOutput) {
        onUpdatePlans({
          mappingConfigurationId: mappingConfigurationId,
          planProfileMappings: plans.map((_) => {
            return { ..._, isLive: _.isLive ? _.isLive : false };
          }),
        }).then((res) => {
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: `Update Profile Plans Succesfull`,
            })
          );
          dispatch(
            UpdateApiMappings({
              modelName: "planProfiles",
              data: res,
            })
          );
        });
      } else {
        onUpdateOutputPlans({
          mappingConfigurationId: mappingConfigurationId,
          outputPlanProfileMapping: plans.map((_) => {
            return { ..._, isLive: _.isLive ? _.isLive : false };
          }),
        }).then((res) => {
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: `Update Profile Plans Succesfull`,
            })
          );
          dispatch(
            UpdateApiMappings({
              modelName: "outputPlanProfiles",
              data: res,
            })
          );
        });
      }
    }
    setAddedPlansFilter(plans);
    setSavedPlans(plans);
    setSearchAddedPlans("");
    setSearchPlanList("");
    setModalOpen(false);

    document.getElementById("NumberOfPlansAdded").textContent =
      savedPlans.length;
  };

  const onCancel = () => {
    setAddedPlans(savedPlans);
    setAddedPlansFilter(savedPlans);
    let temp = allPlans.filter(
      (plan) => !savedPlans.map((item) => item.planId).includes(plan.planId)
    );
    setPlans(temp);
    setPlanListFilter(temp);
    setSearchAddedPlans("");
    setSearchPlanList("");
    setModalOpen(false);
  };

  const addAllPlans = () => {
    setAddedPlans([...planListFilter, ...addedPlans]);
    var list = planListFilter.filter((team) => {
      return (
        team.planName.toLowerCase().includes(searchAddedPlans.toLowerCase()) ||
        team.rkPlanNumber.includes(searchAddedPlans)
      );
    });
    setAddedPlansFilter([...list, ...addedPlansFilter]);
    var temp = plans.filter(
      (plan) => !planListFilter.map((item) => item.planId).includes(plan.planId)
    );
    setPlans(temp);
    setPlanListFilter([]);
  };

  const removeAllPlans = () => {
    setPlans([...addedPlansFilter, ...plans]);
    var list = addedPlansFilter.filter((team) => {
      return (
        team.planName.toLowerCase().includes(searchPlanList.toLowerCase()) ||
        team.rkPlanNumber.includes(searchPlanList)
      );
    });
    setPlanListFilter([...list, ...planListFilter]);
    var temp = addedPlans.filter(
      (plan) =>
        !addedPlansFilter.map((item) => item.planId).includes(plan.planId)
    );
    setAddedPlans(temp);
    setAddedPlansFilter([]);
  };

  useDeepEffect(() => {
    setSavedPlansFilter(savedPlans);
  }, [savedPlans]);

  useDeepEffect(() => {
    applyFiltersClick();
    let temp = [];
    if (!isEmpty(addedPlans)) {
      temp = allPlans.filter(
        (plan) => !addedPlans.map((item) => item.planId).includes(plan.planId)
      );
    } else if (!isEmpty(mappedPlans)) {
      temp = allPlans.filter(
        (plan) => !mappedPlans.map((item) => item.planId).includes(plan.planId)
      );
    } else {
      temp = allPlans;
    }
    setPlans(temp);
    setPlanListFilter(temp);
  }, [allPlans, mappedPlans]);

  useDeepEffect(() => {
    setAddedPlansFilter(
      addedPlans?.filter((team) => {
        return (
          team.planName
            .toLowerCase()
            .includes(searchAddedPlans.toLowerCase()) ||
          team.rkPlanNumber.includes(searchAddedPlans)
        );
      })
    );
  }, [searchAddedPlans]);

  useDeepEffect(() => {
    setSavedPlansFilter(
      savedPlans.filter((team) => {
        return (
          team.planName
            .toLowerCase()
            .includes(searchSavedPlans.toLowerCase()) ||
          team.rkPlanNumber.includes(searchSavedPlans)
        );
      })
    );
  }, [searchSavedPlans]);

  useDeepEffect(
    () => {
      setPlanListFilter(
        plans.filter((team) => {
          return (
            team.planName
              .toLowerCase()
              .includes(searchPlanList.toLowerCase()) ||
            team.rkPlanNumber.includes(searchPlanList)
          );
        })
      );
    },
    [searchPlanList],
    [plans]
  );

  const removePlansFromPlanGroup = (data) => {
    setAddedPlans(addedPlans.filter((e) => e.planId !== data.planId));
    setAddedPlansFilter(
      addedPlansFilter.filter((e) => e.planId !== data.planId)
    );
    setPlans((e) => [data, ...e]);
    if (
      data.planName.toLowerCase().includes(searchPlanList.toLowerCase()) ||
      data.rkPlanNumber.includes(searchPlanList)
    ) {
      setPlanListFilter((e) => [data, ...e]);
    }
  };

  const hideTags = () => {
    let x = document.getElementsByClassName("tags-filter");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };

  useDeepEffect(() => {
    setSelectedCount(0);

    if (!isEmpty(tags)) {
      setSelectedCount(0);
      let arr = [];
      [1, 2, 3, 4, 5, 6, 7].map((filterIndex) => {
        (tags[filterIndex] || []).map((data, index) =>
          data.map((item, idx) => arr.push(item.label))
        );
      });
      setSelectedCount(arr.length);
    } else {
      setSelectedCount(0);
    }
  }, [tags]);

  return (
    <div>
      <SliderPanel
        screen="plan-group"
        isOpen={isModalOpen}
        size="90"
        showCancel={false}
      >
        <LoaderWrapper isLoading={loader}>
          <div className="w-100 h-100 planSliderContainer">
            <div className="d-flex justify-content-between">
              <div className="planTitle pr-5">Add plans</div>
              <div className="pl-5">
                <Button variant="secondary" onClick={() => onCancel()}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    onSubmit(addedPlans);
                  }}
                  className="ml-4"
                >
                  Save
                </Button>
              </div>
            </div>

            <div className="addPlansContent ">
              <div className="leftcol">
                <div className="col1">
                  <div className="left-title12">
                    <div className="planTitle">Filter</div>
                    <div className="resetApplyButtonsContainer">
                      <Link
                        className="planGroupReset"
                        onClick={() => clearFilterValues()}
                      >
                        Reset
                      </Link>
                      <Link
                        className="planGroupApply"
                        onClick={() => applyFiltersClick()}
                      >
                        Apply
                      </Link>
                    </div>
                  </div>
                  <div
                    className="filtersCount d-flex flexD-col"
                    style={{ overflowY: "scroll" }}
                  >
                    <div className="d-flex justify-content-space-between">
                      <div>
                        <span>{selectedCount}</span> Selected
                      </div>
                      <div className="Arrow-up">
                        <Link onClick={hideTags}>
                          <FontAwesomeIcon icon={faChevronDown} />
                        </Link>
                      </div>
                    </div>
                    <div className="tags-filter" style={{ display: "none" }}>
                      <div>
                        <div className="filterTags marg-top-5 pad-top-15">
                          {[1, 2, 3, 4, 5, 6, 7].map((filterIndex) => {
                            return (tags[filterIndex] || []).map(
                              (data, index) =>
                                data.map((item, idx) => (
                                  <div className="flex-start">
                                    <div className="tags">
                                      <div className="filter-text">
                                        <AddToolTip name={item.label}>
                                          {(item.label || "").slice(0, 10)}...{" "}
                                        </AddToolTip>
                                      </div>
                                      <div className="filter-cross-icon">
                                        <Link
                                          onClick={() =>
                                            onDeleteFilterClick(
                                              filterIndex,
                                              item.value
                                            )
                                          }
                                        >
                                          <i
                                            class="fal fa-times Color-primary1 "
                                            aria-hidden="true"
                                          ></i>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                ))
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="filtersMapper">
                    <div className="filterTitleMapper">Plan type</div>
                    <div
                      className=" marg-bot-15"
                      style={{ height: "auto", width: "360px" }}
                    >
                      <Dropside
                        size="sm"
                        direction="bottom"
                        name={"planTypes"}
                        label={"Type"}
                        placeholder={"0 selected"}
                        options={planTypes}
                        value={toMultiSelectValueById(
                          selectedPlanTypes,
                          planTypes
                        )}
                        isMultiSelect
                        // disabled={isEdit}
                        popupContent={
                          <div>
                            <FiltersDropDown
                              //label="Select Plan Types"
                              hideSelectedOptions="FALSE"
                              width="22.3rem"
                              height={planTypes.length * 36}
                              maxHeight="238px"
                              options={planTypes}
                              onSelect={(value) => {
                                setSelectedPlanTypes(value);
                                handleFilters(1, value);
                              }}
                              name={"planTypes"}
                              value={selectedPlanTypes}
                              // disabled={isEdit}
                              // isTypeAhead={isEdit}
                            />
                          </div>
                        }
                      />
                    </div>

                    <div className="filterTitleMapper">Company name</div>
                    <div
                      className=" marg-bot-15"
                      style={{ height: "auto", width: "360px" }}
                    >
                      <Dropside
                        size="xs"
                        direction="bottom"
                        name={"companyOptions"}
                        label={"Type"}
                        placeholder={"0 selected"}
                        options={companyOptions}
                        value={toMultiSelectValueById(
                          selectedCompanyNames,
                          companyOptions
                        )}
                        isMultiSelect
                        // disabled={isEdit}
                        popupContent={
                          <div>
                            <FiltersDropDown
                              //label="Select Plan Types"
                              hideSelectedOptions="FALSE"
                              width="22.3rem"
                              height={companyOptions.length * 50}
                              maxHeight="238px"
                              options={companyOptions}
                              onSelect={(value) => {
                                setSelectedCompanyNames(value);
                                handleFilters(2, value);
                              }}
                              name={"companyOptions"}
                              value={selectedCompanyNames}
                              // disabled={isEdit}
                              // isTypeAhead={isEdit}
                            />
                          </div>
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="leftcol-2">
                  <div className="marg-left-13">
                    <div className="title-case marg-top-15 marg-bot-15">
                      Plans information
                    </div>
                    <div>
                      <div style={{ width: "410px" }}>
                        <Form>
                          <div className="flex-search">
                            <InputGroup>
                              <InputGroup.Prepend>
                                <div className="searchIconPostion">
                                  <i
                                    class="fal fa-search"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </InputGroup.Prepend>

                              <SearchBar
                                size="md"
                                type="search"
                                placeholder="Search plan name & ID"
                                className="PadLeftSearch"
                                onChange={(e) =>
                                  setSearchPlanList(e.target.value)
                                }
                              />
                            </InputGroup>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                  <div className="smallOptions">
                    <div className="small-text w-310">
                      {
                        planListFilter.filter((item) => item.planStatus == 3)
                          .length
                      }{" "}
                      Plan(s)
                    </div>
                    <div className="small-text w-45 marg-left-30">
                      <Link className="link" onClick={() => addAllPlans()}>
                        Add all
                      </Link>
                    </div>
                  </div>

                  <div className="AddPlanTiles marg-right-18">
                    {planListFilter
                      .filter((item) => item.planStatus == 3)
                      .map((data, index) => (
                        <Row>
                          <div className="tile">
                            <div className="tile-line green"></div>
                            <div
                              style={{ width: "18rem" }}
                              className="tile-text pad-left-15"
                            >
                              {/* <div className="tile-title w-269  add-plans-card-text"> */}
                              <CustomToolTip
                                maxWidth="18rem"
                                className="tile-title "
                                displayText={`${data.planName} `}
                              />
                              {/* <div>{data.planName}  </div>  */}
                              {/* {data.planStatus} */}
                              {/* </div> */}
                              <div className="tile-number">
                                <div className="d-flex">
                                  <div> {data.rkPlanNumber} </div>

                                  <div className="ml-2">
                                    <CustomToolTip
                                      maxWidth="10rem"
                                      className="tile-state-gray"
                                      displayText={`${data.companyName} `}
                                    />
                                  </div>
                                  {/* <div className="tile-state-gray add-plans-card-text" style={{ marginLeft: 'auto', maxWidth: '10rem' }}>
                                    {data.companyName} 
                                  </div> */}

                                  {/* <span className="tile-state-red">
                                  {data.planStatus}
                                </span> */}
                                </div>
                              </div>
                            </div>
                            <Link className="ml-auto mr-3">
                              <div className="Arrow">
                                <i
                                  className="fa fa-long-arrow-right"
                                  aria-hidden="true"
                                  onClick={() => addPlansToPlanGroup(data)}
                                ></i>
                              </div>
                            </Link>
                          </div>
                        </Row>
                      ))}
                  </div>
                </div>
              </div>

              <div className="maintenancePlanRight">
                <div className="maintenancePlanRight-1">
                  <div className="title-case marg-top-15 marg-bot-15  ">
                    Added plans
                  </div>
                  <div className="w-381 ">
                    <Form>
                      <InputGroup>
                        <InputGroup.Prepend>
                          <div className="search-icon-postion">
                            <i class="fal fa-search" aria-hidden="true"></i>
                          </div>
                        </InputGroup.Prepend>
                        <SearchBar
                          size="md"
                          type="search"
                          placeholder="Search plan name & ID"
                          onChange={(e) => setSearchAddedPlans(e.target.value)}
                          className="pad-left-search"
                        />
                      </InputGroup>
                    </Form>
                  </div>

                  <div className="plan-group-remove-count">
                    <div className="plan-group-remove">
                      <Link
                        className="link red-small"
                        onClick={() => removeAllPlans()}
                      >
                        Remove all
                      </Link>
                    </div>
                    <div
                      className="plan-group-plan"
                      style={{
                        marginLeft: "270px",
                      }}
                    >
                      {addedPlansFilter.length} Plan(s)
                    </div>
                  </div>

                  {isEmpty(addedPlans) ? (
                    <div className="plan-group-no-plan">
                      <div className="plan-no-plan">No plans added</div>
                      <div className="plan-add-plan">
                        Please add plans here by clicking on the arrow
                      </div>
                    </div>
                  ) : (
                    <div className="added-plans-list">
                      {addedPlansFilter.map((data, index) => (
                        <Row>
                          <div className="tile-added">
                            <Link>
                              <div className="Arrow-left m-0 pl-3 pr-2">
                                <i
                                  className="fa fa-long-arrow-left"
                                  aria-hidden="true"
                                  onClick={() => removePlansFromPlanGroup(data)}
                                ></i>
                              </div>
                            </Link>
                            <div className="tile-text-added w-add-plan-button">
                              {/* <div className="tile-title">{data.planName}</div> */}
                              <div className="d-flex w-100">
                                <div
                                  style={{
                                    maxWidth: "100px",
                                    overflow: "visible",
                                    width: "35%",
                                  }}
                                >
                                  <CustomToolTip
                                    maxWidth="6rem"
                                    className="tile-title"
                                    displayText={`${data.planName}`}
                                  />
                                  <div style={{ marginLeft: "1rem" }}>
                                    {data.rkPlanNumber}
                                  </div>
                                </div>

                                <div
                                  className="tile-number d-flex"
                                  style={{
                                    width: "35%",
                                  }}
                                >
                                  <CustomToolTip
                                    maxWidth="6rem"
                                    className="tile-state-gray mr-2"
                                    displayText={`${data.companyName}  `}
                                  />

                                  {/* <span className="tile-state-gray">
                                  {data.companyName}
                                </span> */}
                                </div>

                                <div
                                  className="w-40"
                                  style={{
                                    marginLeft: "2.6rem",
                                  }}
                                >
                                  <div
                                    style={{
                                      color: "#828282",
                                      fontSize: "12px",
                                    }}
                                  >
                                    Mode
                                  </div>
                                  <CustomToggleButton
                                    idName={data.planId}
                                    isChecked={data.isLive}
                                    onChangeFunction={(val) => {
                                      setAddedPlansFilter(
                                        addedPlansFilter.map((_) => {
                                          if (_.planId === data.planId) {
                                            return { ...data, isLive: val };
                                          }
                                          return _;
                                        })
                                      );
                                      setAddedPlans(
                                        addedPlans.map((_) => {
                                          if (_.planId === data.planId) {
                                            return { ...data, isLive: val };
                                          }
                                          return _;
                                        })
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="tile-line-right green"></div>
                          </div>
                        </Row>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </LoaderWrapper>
      </SliderPanel>

      <SliderPanel
        screen="plan-group"
        isOpen={isEditSliderOpen}
        size="35"
        showCancel={false}
        showCancelButton={true}
        onClose={() => setEditSliderOpen(false)}
        showEdit={true}
        onEdit={onEditAddedPlansButtonClick}
        showHeader={true}
        header={"Added Plans"}
        headerClass="slider-title-case"
        showSeparator={true}
      >
        <div>
          <div className="editSliderHeader-2">
            <div className="plan-group-plan editSliderAddedPlans">
              {savedPlansFilter.length} Plans
            </div>
          </div>
        </div>

        <div className="w-381 editSearchBar">
          <Form>
            <InputGroup>
              <InputGroup.Prepend>
                <div className="search-icon-postion">
                  <i class="fal fa-search" aria-hidden="true"></i>
                </div>
              </InputGroup.Prepend>
              <SearchBar
                size="md"
                type="search"
                placeholder="Search plan name & ID"
                onChange={(e) => setSearchSavedPlans(e.target.value)}
                className="pad-left-search"
              />
            </InputGroup>
          </Form>
        </div>

        <div className="editSliderAddedPlansList">
          {savedPlansFilter.map((data, index) => (
            <Row>
              <div className="ShowAddedPlanTile">
                <div className="tile-line green"></div>
                <div className="editSliderTileTitle  pad-left-15">
                  <div className="tile-title">{data.planName}</div>
                  <div className="tile-number">
                    {data.rkPlanNumber}
                    <span className="tile-state-gray">{data.companyName}</span>
                  </div>
                </div>
              </div>
            </Row>
          ))}
        </div>
      </SliderPanel>

      {isEmpty(savedPlans) ? (
        <div style={{ width: "60px", marginLeft: "70px" }}>
          <AddPlanButton
            className="AddPlan"
            buttonLabel="Add"
            onPrimaryClick={onViewButtonClick}
            // disabled={isEdit && !isSave}
          />
        </div>
      ) : (
        <div style={{ width: "60px", marginLeft: "70px" }}>
          <AddPlanButton
            className="AddPlan"
            buttonLabel="View"
            onPrimaryClick={onEditButtonClick}
            // disabled={isEdit && !isSave}
          />
        </div>
      )}
    </div>
  );
};

export default ManageAddPlanButton;
